import type { SidebarViewProps } from "#public"

import { PanelInformations } from "../components/PanelInformations"
import { PresetSelect } from "../components/PresetSelect"
import { ImpositionForm } from "../forms/ImpositionForm"

export function ImpositionView({
  fields,
  hidden_fields,
  informations,
  node,
  on_preset,
  page_counts,
  sheet_math,
  preset_id,
  presets,
  store,
  view,
}: SidebarViewProps) {
  return (
    <div className="flex flex-1 flex-col gap-2 px-2">
      <PresetSelect on_change={on_preset} presets={presets} value={preset_id} />
      {node && (
        <ImpositionForm
          view={view}
          hidden_fields={hidden_fields}
          node={node}
          staff={true}
          store={store}
        />
      )}
      <PanelInformations
        fields={fields}
        informations={informations}
        page_counts={page_counts}
        sheet_math={sheet_math}
        store={store}
      />
    </div>
  )
}
